<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("add") }} {{ $t("institution") }}
      </div>
      <div>
        <router-link class="btn-blue" to="institution"
          >{{ $t("institution") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                type="text"
                v-validate="{ required: 'required', regex: /^[a-zA-Z0-9- ]*$/ }"
                name="institution_name"
                id="institution_name"
                v-model="institutionDetails.institution_name"
              />
              <label>{{ $t("institution") }} {{ $t("name") }}</label>
            </div>
            <Tooltip :title="$t('institutionName')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('institution_name')">{{
              errors.first("institution_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="selected.Cinema.length > 0 ? 'shift-up' : ''"
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="selected.Cinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <div class="px-2 pb-2">
                  <input
                    required
                    autofocus
                    type="search"
                    :placeholder="$tc('searchCinema')"
                    class="form-control form-control-sm"
                    v-on:keyup="onSearchCinema()"
                    v-on:keydown="onSearchCinema()"
                    v-on:search="onSearchCinema()"
                    v-model="searchCinema"
                  />
                </div>
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in Cinemas"
                  :key="cinemaIndex"
                  @click="onSelectHandler('cinema', cinema)"
                  name="selectcinema"
                  id="selectcinema"
                  >{{ cinema.cine_name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="$t('institutionCinema')" />
            </div>
            <p class="error_message">
              <span v-if="submitted && selected.Cinema.length == 0"
                >{{ $t("pleaseSelectCinema") }}.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  v-model="institutionDetails.institution_is_active"
                  unchecked-value="N"
                  value="Y"
                  switch
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="onResetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="institution"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketingService from "@/services/MarketingService";
import MasterService from "@/services/MasterService";
import moment from "moment";
import { METHODS } from "http";
export default {
  data() {
    return {
      CinemasCopy: [],
      searchCinema: "",
      btenable: false,
      selected: {
        Cinema: ""
      },
      submitted: false,
      institutionDetails: {
        cinema_id: "",
        institution_name: "",
        institution_is_active: "Y"
        // cinema_name: ""
      },
      cine_id: "",
      cine_name: "",
      Cinemas: [],
      CinemasMethod: {
        GET: "/admin/tablelist/",
        tableName: "ms_cinemas",
        urlKey: "cinemas"
      }
    };
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;

    this.getCinemasList(obj);
  },
  methods: {
    onSearchCinema: function() {
      if (this.searchCinema && this.searchCinema.length > 0) {
        this.Cinemas = this.CinemasCopy.filter(x => {
          if (
            x.cine_name.toLowerCase().includes(this.searchCinema.toLowerCase())
          ) {
            return x;
          }
        });
      } else {
        this.Cinemas = this.CinemasCopy;
      }
    },
    onResetForm: function() {
      this.cinema_id = "";
      (this.institutionDetails.institution_name = ""),
        (this.cinema_name = ""),
        (this.selected = {
          Cinema: ""
        });
    },
    getCinemasList: function(cine_id) {
      this.Cinemas = [];
      // let payload = {
      //   tableName: "ms_cinemas",
      //   cine_is_active: "Y"
      // };
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    onFinalSubmit: function(redirect) {
      this.submitted = true;
      this.$validator
        .validate()
        .then(valid => {
          // console.log("Valid :", valid);
          if (this.institutionDetails.cinema_id.length == 0) {
            return;
          }
          if (valid) {
            this.btenable = true;
            MarketingService.addInstitution({
              ...this.institutionDetails
            }).then(response => {
              this.btenable = false;
              const { data } = response;
              if (data.status) {
                this.$toasted.show(data.message);

                this.onResetForm();
                if (redirect) {
                  // console.log("redirect value ", redirect);
                  this.$router.push({
                    path: "/marketing/institution"
                  });
                }
              } else {
                this.$toasted.show(data.message);
              }
            });
          }
        })
        .catch(this._CatchError);
    },

    onSelectHandler: function(type, value) {
      if (type == "cinema") {
        this.institutionDetails.cinema_id = value.cine_id;
        this.selected.Cinema = value.cine_name;
        this.searchCinema = "";
        this.onSearchCinema();
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/InstitutionComponents/addInstitution.vue